module.exports = __webpack_public_path__ + "487e562d919c9945b42c07a9763aec5f.svg";